import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';

const modeloDatos = {
   id: 0, 
    nombre: "",
    descripcion: "",
    url: "",
    fechaCreado: new Date
   
}

const Vip = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);

    const handleChange = (e) => {
        let value = e.target.nodeName === "SELECT" ? (e.target.value == "true" ? true : false) : e.target.value;
        setTabla({
            ...tabla,
            [e.target.name]: value
        })
    }


    const obtenerDatos = async () => {
        let response = await fetch(Api + "Administracion/VIP");

        if (response.ok) {
            let data = await response.json()
            SetListado(data)
            setPendiente(false)
        }
    }

    useEffect(() => {
        obtenerDatos();
    })


    const guardarCambios = async () => {
      

        let response;
        if (tabla.id == 0) {
          
            response = await fetch(Api + "Administracion/GuardarVIP", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "Administracion/EditarVIP", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            await obtenerDatos();
            setTabla(modeloDatos)
            setVerModal(!verModal);
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
        } else {
            alert("error al guardar")
        }

    }

    const eliminarDatos = async (id) => {

        Swal.fire({
            title: 'Esta seguro?',
            text: "Desea eliminar el producto",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, continuar',
            cancelButtonText: 'No, volver'
        }).then((result) => {
            if (result.value) {

                const response = fetch(Api + "evaluaciondesempeno/EliminarPregunta/" + id, { method: "DELETE" })
                    .then(response => {
                        if (response.ok) {

                            obtenerDatos();

                            Swal.fire(
                                'Eliminado!',
                                'El producto fue eliminado.',
                                'success'
                            )
                        }
                    })
            }
        })
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'ID',
            selector: row => row.id,
            sortable: true,
        },
        {
            name: 'Descripcion',
            selector: row => row.descripcion,
            sortable: true,
        },
       
       
        //{
        //    name: 'Estado',
        //    selector: row => row.esActivo,
        //    sortable: true,
        //    cell: row => {
        //        let clase;
        //        clase = row.esActivo ? "badge badge-info p-2" : "badge badge-danger p-2"
        //        return (
        //            <span className={clase}>{row.esActivo ? "Activo" : "No Activo"}</span>
        //        )
        //    }
        //}
        
        {
            name: '',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                     onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>

                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de Vip
                </CardHeader>
                <CardBody>
                    <Button color="success" size="sm"
                    onClick={() => setVerModal(!verModal)}
                    >Nuevo Vip</Button>
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal}>
                <ModalHeader className="modal-header1">
                    Mantenimiento de Vip
                </ModalHeader>
                <ModalBody>
                    <Row>
                    <Col >
                    <FormGroup>
                    
                        <Label>Nombre</Label>
                                <Input bsSize="sm" name="nombre" onChange={handleChange} value={tabla.nombre} />
                        </FormGroup></Col> <Col >
                    <FormGroup>
                    
                        <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                        </FormGroup></Col>
                  </Row> <Row>
                    <Col >
                    <FormGroup>
                    
                        <Label>URL</Label>
                                <Input bsSize="sm" name="url" onChange={handleChange} value={tabla.url} />
                        </FormGroup></Col> <Col >
                    <FormGroup>
                    
                        <Label>Descripcion</Label>
                                <Input bsSize="sm" type="date"name="fechaCreado" onChange={handleChange} value={tabla.fechaCreado} />
                        </FormGroup></Col>
                  </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                      onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
        


        </>
        )

}
export default Vip;